export const PieGraphTileDefaultColors: string[] = [
   '#00a6e0',
   '#53d3ff',
   '#006486',
   '#ffa630',
   '#eb343c',
   '#94cc86',
   '#363b4d',
   '#5f6475',
   '#8d99ae',
   '#2b376b',
   '#262d4c',
   '#bbc2ce',
   '#4e5a6e',
   '#fcb716',
   '#a27202',
];
